import { useTranslation } from 'react-i18next';
import preloadChunks from '@/routes/preloadChunks.util';
import useReview from '@/pages/ReviewLayout.context';
import Button from '@/components/Button';
import styles from '../Welcome.module.scss';

const Reviewer = () => {
  const { t } = useTranslation(['review']);
  const { review, reviewerStatusId, visitor } = useReview();

  const handlePreload = () => {
    void preloadChunks['review.document']();
  };

  if (!review || !visitor) {
    return null;
  }

  return (
    <>
      <div className={styles.p}>
        {t('review:welcome.greeting', { name: visitor.name })}
      </div>
      <div className={styles.p}>
        {t('review:welcome.intro', {
          docName: review.signing.name,
        })}
      </div>

      {review.status === 'APPROVED' && (
        <div className={styles.notice}>{t('review:welcome.stateApproved')}</div>
      )}
      {review.status === 'REJECTED' && (
        <div className={styles.notice}>{t('review:welcome.stateRejected')}</div>
      )}

      <div className={styles.start}>
        {review.status === 'PENDING' && (
          <Button
            as="link"
            className={styles.button}
            variant="primary"
            to={`/review/${reviewerStatusId}/document`}
            onMouseEnter={handlePreload}
            onFocus={handlePreload}
            replace
          >
            {t('review:welcome.cta')}
          </Button>
        )}
      </div>

      <>
        <h2 className={styles.h2}>{t('review:welcome.stepsHeadline')}</h2>
        <ol className={styles.explanation}>
          <li className={styles.step}>{t('review:welcome.step1')}</li>
          <li className={styles.step}>{t('review:welcome.step2')}</li>
          <li className={styles.step}>{t('review:welcome.step3')}</li>
        </ol>
        <div className={styles.outro}>{t('review:welcome.stepsOutro')}</div>
      </>
    </>
  );
};

export default Reviewer;
